import React, {Component} from 'react';
import queryString from 'query-string'; 

import TasSwitch from '../../../components/TasSwitch';

import BranchCards, {initData as ContractCardsInit } from './BranchCards';
import ContractChart from './ContractChart';
import TerminateChart from './TerminateChart';
import DerivativeChart from './DerivativeChart';
import BizAreaTable from './BizAreaTable';
import NurseryList from './NurseryList';
import ContractYearPie from './ContractYearPie';
import NurseryTypePie from './NurseryTypePie';

import * as Constant from '@app/Constant.js';

import axios from '@app/lib/axios';

const calculateData = (_new, _renew, _terminate, last_new, last_renew, last_terminate) => {

    return {
        total : _new + _renew,
        total_growth : last_new + last_renew == 0 && last_new + last_renew > 0 ? 100 : last_new + last_renew <= 0 ? 0 : Math.ceil( ( ((_new+ _renew) - (last_new+ last_renew)) / (last_new + last_renew))*100 ),

        new_growth : last_new == 0 && _new > 0 ? 100 : last_new == 0 && _new <= 0 ? 0 : Math.ceil( ( (_new - last_new) / (last_new))*100 ),
        
        renew_growth : last_renew == 0 ? 0 : Math.ceil( ((_renew - last_renew) / (last_renew))*100 ),

        last_total : last_new+ last_renew,

        renew_rate : last_new + last_renew == 0 ? 0 : Math.ceil((_renew / (last_new + last_renew) ) * 100 ),
        terminate_rate : _new == 0 ? 0 : Math.ceil((_terminate / _new) * 100 ),



        new : _new,
        renew : _renew,
        terminate : _terminate,
        last_new : last_new,
        last_renew : last_renew,
        last_terminate : last_terminate
    }
}


class TasBranch extends Component {

	constructor(props) {
		super(props);
        const query =  queryString.parse(this.props.location.search);

        var year = query && query.year ? query.year : new Date().getFullYear();
		this.state = {
            tomonote : true,
            tomobooks : false,
            data : null,
            year : year,
            addr : "",
            id : localStorage.getItem("login_branch_id"),
            branch_title : "Loading..."
		};
	}

    componentDidMount(){    
        this.getContractData(this.state.tomonote, this.state.tomobooks, this.state.id);
    }

    componentWillReceiveProps = (nextProps) => {
        this.getContractData(this.state.tomonote, this.state.tomobooks, localStorage.getItem("login_branch_id"));
    }

    getContractData = (tomonote, tomobooks, branchId) => {
        axios({
          method: "get",
          url: Constant.API_DOMAIN + "/api/petit/branchInfo/" + this.state.id
        })
          .then(result => {
            if(result.data.code === 200) {
                this.setState({
                    data : result.data.data, 
                    id : branchId
                }, () => this.drawDashboard(tomonote, tomobooks));
            } 
            
          })
          .catch(error => {
            console.log(error);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
        });
        
    }


    yearChange = (year) => {
        this.setState({
            year : year,
            chartData : [],
            thisYear : ContractCardsInit
        },() => this.drawDashboard(this.state.tomonote, this.state.tomobooks))
    }


    drawDashboard = (tomonote, tomobooks) => {

        var name = this.state.data.name;
        var stat = this.state.data.status;
        var contract_year = this.state.data.contract_year;
        var terminate_year = this.state.data.terminate_year;

        var tomonoteBranchList = this.state.data.tomonote;
        var tomobooksBranchList = this.state.data.tomobooks;

        var nurseryMap = {};
        var thisYearNurseryList = [];

        var yearList = [];

        var thisYear = {}; 


        this.state.data.targetYears.forEach(year =>{
            var _new = 0;
            var _renew = 0;
            var _terminate = 0;
            var last_new = 0;
            var last_renew = 0;
            var last_terminate = 0;
            var renew_terminate = 0;

            if(tomonote) {
                tomonoteBranchList.forEach(nursery => {
                    if(nursery["validateBranch_" + year.year]){
                        _new += nursery["n_" + year.year];
                        _renew += nursery["rn_" + year.year];
                        _terminate += nursery["t_" + year.year];
                        renew_terminate += nursery["renew_t_" + year.year];
                    }
                    
                    if(nursery["validateBranch_" + (year.year-1)]){
                        last_new += nursery["n_" + (year.year-1)];
                        last_renew += nursery["rn_" + (year.year-1)];
                        last_terminate += nursery["t_" + (year.year-1)];
                    }

                    
                    if(this.state.year == year.year && nursery["validateBranch_" + year.year]) {
                        nurseryMap[Number(nursery.id)] = {
                            name : nursery.name,
                            loc_code : nursery.loc_code,
                            type : nursery.type,
                            new : nursery["n_" + year.year],
                            renew : nursery["rn_" + year.year],
                            terminate : nursery["t_" + year.year],
                            last_new : nursery["n_" + (year.year-1)],
                            last_renew : nursery["rn_" + (year.year-1)],
                            last_terminate : nursery["t_" + (year.year-1)]
                        };
                    } 
                });
            }

        
            if(tomobooks) {
                tomobooksBranchList.forEach(nursery => {
                    if(nursery["validateBranch_" + year.year]){
                        _new += nursery["n_" + year.year];
                        _renew += nursery["rn_" + year.year];
                        _terminate += nursery["t_" + year.year];
                    }
                    
                    if(nursery["validateBranch_" + (year.year-1)]){
                        last_new += nursery["n_" + (year.year-1)];
                        last_renew += nursery["rn_" + (year.year-1)];
                        last_terminate += nursery["t_" + (year.year-1)];
                    }


                    if(this.state.year == year.year && nursery["validateBranch_" + year.year]) {
                        
                        var tomonoteData = nurseryMap[nursery.id];

                        if(tomonoteData) {
                            nurseryMap[Number(nursery.id)] = {
                                name : nursery.name,
                                loc_code : nursery.loc_code,
                                type : nursery.type,
                                new : tomonoteData.new + nursery["n_" + year.year],
                                renew : tomonoteData.renew + nursery["rn_" + year.year],
                                terminate : tomonoteData.terminate + nursery["t_" + year.year],
                                last_new : tomonoteData.last_new + nursery["n_" + (year.year-1)],
                                last_renew : tomonoteData.last_renew + nursery["rn_" + (year.year-1)],
                                last_terminate : tomonoteData.last_terminate + nursery["t_" + (year.year-1)]
                            }
                        } else {
                            nurseryMap[Number(nursery.id)] = {
                                name : nursery.name,
                                loc_code : nursery.loc_code,
                                type : nursery.type,
                                new : nursery["n_" + year.year],
                                renew : nursery["rn_" + year.year],
                                terminate : nursery["t_" + year.year],
                                last_new : nursery["n_" + (year.year-1)],
                                last_renew : nursery["rn_" + (year.year-1)],
                                last_terminate : nursery["t_" + (year.year-1)]
                            };
                        }
                        
                    } 
                });
            }

            var nurseryKeyList = Object.keys(nurseryMap);

            thisYearNurseryList = [];
            nurseryKeyList.forEach(key=> {
                var nurseryData = nurseryMap[key];

                thisYearNurseryList.push({
                    id : key,
                    name : nurseryData.name,
                    loc_code : nurseryData.loc_code,
                    type : nurseryData.type === 'K' ? "유치원" : nurseryData.type === 'D' ?  "어린이집" : "기타" ,
                    data : calculateData(nurseryData.new, nurseryData.renew, nurseryData.terminate, nurseryData.last_new, nurseryData.last_renew, nurseryData.last_terminate)
                });
            });



            // 임시 랜덤 
            var books = Math.ceil(Math.random() * (100 - 30) + 30);
            var playkit = Math.ceil(Math.random() * (100 - 30) + 30);
            var kidsfarm = Math.ceil(Math.random() * (100 - 30) + 30);
            var experience = Math.ceil(Math.random() * (100 - 30) + 30);

            var yearTotalData = calculateData(_new, _renew, _terminate, last_new, last_renew, 0);
            
            yearList.push({
                name : year.year,
                "신규": _new, 
                "재계약": _renew, 
                "재계약률": yearTotalData.renew_rate, 
                "신규해지" : _terminate,
                "재계약해지" : renew_terminate,
                "해지율" : Math.ceil( ((_terminate + renew_terminate) / yearTotalData.total) * 100),
                "토모동화" : books,
                "플레이키트" : playkit,
                "키즈팜" : kidsfarm,
                "체험관" : experience
            });

            if(this.state.year == year.year) {
                thisYear = yearTotalData;
                thisYear.terminate = _terminate;
                thisYear.renew_terminate = renew_terminate;

                thisYear.books = books;
                thisYear.playkit = playkit;
                thisYear.kidsfarm = kidsfarm;
                thisYear.experience = experience;

            }

        });

    
        thisYearNurseryList.forEach(nursery => {
            nursery.data.rate = thisYear.total == 0 ? 0 : Math.ceil((nursery.data.total / thisYear.total) *100);

            nursery.data.derivative = Math.ceil(Math.random() * (400 - 30) + 30);
        });

       
        var bizAreaMap = {};
        var bizAreaCodes = [];
        if(this.state.data.bizArea) {
            this.state.data.bizArea.forEach(bizArea => {
                var name = bizArea.parentName ? bizArea.parentName + " " + bizArea.name : bizArea.name;
                bizAreaCodes.push(bizArea.loc_code);
                bizAreaMap[bizArea.loc_code] = {
                    name : name,
                    new : 0,
                    renew : 0,
                    is_biz_area : true
                } 
            }); 
        }
        
        if(this.state.data.nurseryBizArea) {
            this.state.data.nurseryBizArea.forEach(bizArea => {
                var isChildArea = false;
                var parentArea = "";
                bizAreaCodes.forEach(biza => {
                    if(bizArea.loc_code.indexOf(biza) == 0) {
                        isChildArea = true;
                        parentArea = biza;
                    }
                });

                if(isChildArea) {
                    delete bizAreaMap[parentArea];
                     
                } 

                var name = bizArea.parentName ? bizArea.parentName + " " + bizArea.name : bizArea.name;
                bizAreaMap[bizArea.loc_code] = {
                    name : name,
                    new : 0,
                    renew : 0,
                    is_biz_area : isChildArea
                }

            }); 
        }

        if(thisYearNurseryList) {
            thisYearNurseryList.forEach(nursery => {
                
                var key = nursery.loc_code ? nursery.loc_code : "unknown";
                var data = bizAreaMap[key];

                if(!data) {
                    key = "unknown";
                    data = {
                        name : "undefind_loc_code",
                        is_biz_area : false,
                        new : 0,
                        renew : 0
                    }
                }
                
                data.new = data.new + nursery.data.new;
                data.renew = data.renew + nursery.data.renew;

                bizAreaMap[key] = data;
            });
        }

        var keys = Object.keys(bizAreaMap);
        var bizAreaList = [];
        keys.forEach(key => {
            bizAreaList.push({
                id : key,
                is_biz_area : bizAreaMap[key].is_biz_area,
                name : bizAreaMap[key].name,
                loc_code : key,
                total : bizAreaMap[key].new + bizAreaMap[key].renew,
                new : bizAreaMap[key].new,
                renew : bizAreaMap[key].renew
            })
        })

        bizAreaList.sort((a, b) => {
            return b.is_biz_area - a.is_biz_area;
        });

        var nurseryTable = [];
        var locCodes = [ "" + bizAreaList[0].loc_code];
        if(thisYearNurseryList != null && locCodes != null) {
            thisYearNurseryList.forEach(nursery => {
                if(locCodes.includes(nursery.loc_code)) nurseryTable.push(nursery);
            }); 
        }

        this.setState({
            branch_title : name ,
            duration : stat !== "join" ? contract_year + " ~ " + terminate_year : contract_year + " ~ " ,
            chartData : yearList,
            thisYearNursery : thisYearNurseryList,
            nurseryTable : nurseryTable,
            thisYear : thisYear,
            bizArea : this.state.data.bizArea,
            nurseryArea : this.state.data.nurseryBizArea,
            bizAreaList : bizAreaList,
            locCodes : locCodes,
            bizAreaNames : bizAreaList[0].parentName ? bizAreaList[0].parentName + " " + bizAreaList[0].name : bizAreaList[0].name ,
            addr : this.state.data.loc_parentName ? this.state.data.loc_parentName + " " + this.state.data.loc_name : this.state.data.loc_name,
            tomonote : tomonote, 
            tomobooks : tomobooks
        });


    } 
    

    tomonoteHandleChange = (checked) => {
        if(!checked && !this.state.tomobooks) {
            alert("토모노트 혹은 토모동화 둘 중 하나라도 선택해야 합니다.");
        } else {
            this.drawDashboard(checked, this.state.tomobooks);
        }
    }


    tomobooksHandleChange = (checked) => {
        if(!checked && !this.state.tomonote) {
            alert("토모노트 혹은 토모동화 둘 중 하나라도 선택해야 합니다.");
        } else {
            this.drawDashboard(this.state.tomonote, checked);    
        }
    }

    bizAreaClick = (areaCode, names) => {
        
        var nurseryTable = [];
        
        
        if(this.state.thisYearNursery != null && areaCode != null) {
            this.state.thisYearNursery.forEach(nursery => {
                if(areaCode.includes(nursery.loc_code)) nurseryTable.push(nursery);
                else if(!nursery.loc_code && areaCode.includes("unknown")) nurseryTable.push(nursery);
            }); 
        }
        var bizAreaNames = names.join(", ");
        this.setState({
            nurseryTable : nurseryTable,
            bizAreaNames : bizAreaNames.substring(0, bizAreaNames.length)
        });

        
    }

	render() {
		return (

			<div className="dashboard-wrapper">
                <div className="dashboard-ecommerce">
                    <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">

                    	<div className="row">
                            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                <div className="page-header">
                                    <h2 className="pageheader-title">{this.state.year}년 {this.state.branch_title}
                                        <span className="text-muted font-16 ml-3" >{this.state.duration}</span>
                                    </h2>
                                     <div className="page-breadcrumb ml-2">
                                        {this.state.addr}
                                    </div>
                                </div>
                               
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12" style={{textAlign: "right"}}>
                                <TasSwitch tomonote={this.state.tomonote} tomobooks={this.state.tomobooks} tomonoteCbFnc={this.tomonoteHandleChange} tomobooksCbFnc={this.tomobooksHandleChange}/>
                            </div>
                        </div>


                    	<div className="row">
                            <BranchCards data={this.state.thisYear}/>
                    	</div>
                    	<div className="row">
                        	<div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <ContractChart year={this.state.year} chartData={this.state.chartData} yearChangeFn={this.yearChange}/>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <TerminateChart year={this.state.year} chartData={this.state.chartData} yearChangeFn={this.yearChange}/>
                            </div>
                       	</div>
                        <div className="row">
                            <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12">
                                <ContractYearPie tomonote={this.state.tomonote} tomobooks={this.state.tomobooks} year={this.state.year} id={this.state.id}  height={300}/>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12">
                                <NurseryTypePie nurseryList={this.state.thisYearNursery}  height={300}/>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <DerivativeChart year={this.state.year} chartData={this.state.chartData} height={300}/>
                            </div>
                            
                        </div>
                       	<div className="row">
                            <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12">
                                <BizAreaTable bizAreaList={this.state.bizAreaList} rowClickCbFnc={this.bizAreaClick}/>
                            </div>
                       		<div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12">
                                <NurseryList nurseryList={this.state.nurseryTable} total={this.state.thisYearNursery ? this.state.thisYearNursery.length : 0} bizAreaNames={this.state.bizAreaNames} year={this.state.year}/>
                            </div>
                       	</div>
                    </div>
                </div>
            </div>

		)
	}


}


export default TasBranch;